<template>
    <div class="share">
        <span class="share__text">Del:</span>
        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`" target="_blank">
            <icon name="facebook" />
        </a>
        <a :href="`https://twitter.com/intent/tweet?text=${twitterText}`" target="_blank">
            <icon name="twitter" />
        </a>
        <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${linkedInTitle}`" target="_blank">
            <icon name="linkedin" />
        </a>
    </div>
</template>

<script>
import Icon from '@/components/Icon';
export default {
    name: 'Share',
    components: {
        Icon
    },
    data () {
        return {
            host: ''
        };
    },
    computed: {
        url () {
            return encodeURI(this.host);
        },
        twitterText () {
            return `Del AtB sin side: ${this.url}`;
        },
        linkedInTitle () {
            return encodeURI('AtB bilkalkulator');
        }
    },
    mounted () {
        this.host = window.location.href;
    }
};
</script>

<style lang="scss">
.share{
    display: flex;
    align-items: center;
    a{
        line-height: 0;
        &:last-of-type{
            margin-left: spacing(1);
        }
    }
    &__text{
        margin-right: spacing(1);
    }
}
</style>
